import type { OsResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import { isEnumValue } from '@ingenico/util-common';
import { toString } from 'lodash-es';
import type { OsListResponseApiMapped } from '../../../models/osList.model';
import { enumOsResourceStatus, OsResourceStatus } from '../../../models/osList.model';

export function mapFromOsResourceListToOsListApi({
  pagination,
  data,
}: OsResourceListResponseV2Api): OsListResponseApiMapped {
  return {
    pagination,
    data: data.map(({ name, compatibleDeviceFamilyNames, creationDate, id, assets, status }) => ({
      assets,
      compatibleDeviceFamilyNames: compatibleDeviceFamilyNames ?? [],
      creationDate,
      id: toString(id),
      name,
      status: isEnumValue(status, enumOsResourceStatus) ? OsResourceStatus[status] : OsResourceStatus.DEPRECATED,
    })),
  };
}
